<template>
  <NuxtLayout name="default" :show-back-button="false">
    <SofaxBreadcrumb :title="t('seo.terms.title')" :items="[{ name: t('seo.terms.title') }]" />

    <section class="sofax bg-white dark:bg-gray-950">
      <div class="section-space">
        <div class="shell">
          <SofaxLegalDocument :document="legalDocument" />
        </div>
      </div>
      <div class="separator" />
    </section>

    <SofaxPageCta />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { termsOfUse } from '~/constants/legal/terms'
import { termsOfUseCs } from '~/constants/legal/termsCs'
import { termsOfUseDe } from '~/constants/legal/termsDe'
import { termsOfUsePl } from '~/constants/legal/termsPl'

const { t, locale } = useI18n()

/*
 * `layout: false` + explicit NuxtLayout so the default layout's back button
 * can be switched off; definePageMeta cannot pass layout props.
 */
definePageMeta({
  layout: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/obchodni-podminky', de: '/nutzungsbedingungen', pl: '/regulamin' } })

const legalDocument = computed(() => (locale.value === 'cs' ? termsOfUseCs() : locale.value === 'de' ? termsOfUseDe() : locale.value === 'pl' ? termsOfUsePl() : termsOfUse()))

// SEO Meta
useSeoMeta({
  title: () => t('seo.terms.title'),
  description: () => t('seo.terms.description'),
  ogTitle: () => t('seo.terms.title'),
  ogDescription: () => t('seo.terms.description'),
})
</script>
